/** Selection set of the `VehicleRemoteCommand` GraphQL type (P3-53960 contract). */
export const VEHICLE_REMOTE_COMMAND_FIELDS = `
	id
	unitId
	provider
	command
	status
	providerStatus
	errorCode
	errorMessage
	requestedByUserId
	requestedByName
	requestedAt
	completedAt
`;
